import {AlertNotification, AlertNotificationSearchTerm, NotificationService, SiteNotificationId} from "@app/shared/services/api/notification.service";
import {CacheById} from "../cache-by-id";
import {HttpUtilityService} from "@app/shared/services/api/http-utility-service";
import {map} from "rxjs";
import {CollectionUtils} from "@app/shared/util/collections/collection-utils";

export class AlertNotificationByIdCache extends CacheById<SiteNotificationId, AlertNotification> {
  static ALERT_NOTIFICATION_DEFAULT_PARAMETERS: AlertNotificationSearchTerm = {fetch_recipients: true, fetch_recipient_preferences: true};
  constructor(
    httpUtilityService: HttpUtilityService,
    notificationService: NotificationService,
    partitionSize: number,
    alertNotificationDefaultParameters: AlertNotificationSearchTerm = AlertNotificationByIdCache.ALERT_NOTIFICATION_DEFAULT_PARAMETERS
) {
    super((notificationIds: SiteNotificationId[]) => {
      const requestFn = (ids: SiteNotificationId[]) => notificationService.searchAlertNotifications(
        {start_index: 0, limit: ids.length},
        {sites_notification_ids: notificationIds, ...alertNotificationDefaultParameters}
      ).pipe(map(response => response.data));
      return httpUtilityService.requestPartitioned(requestFn, notificationIds, partitionSize)
        .pipe(map(alertNotifications => CollectionUtils.indexBy(alertNotifications, 'sites_notification_id')));
    })
  }
}